
import ViewModel from '@/models/ViewModel'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {},
})
class FooterNav extends ViewModel {
  @Prop({ default: 5 })
  public zIndex: number = 5

  @Prop({ default: '' })
  public footerClass!: string

  @Prop({ default: false })
  public hideCancel!: boolean

  @Prop({ default: false })
  public hideConfirm!: boolean

  public get hiddenCancelBtn() {
    return this.hideCancel || typeof this.hideCancel === 'string' ? !this.hideCancel.length : false
  }
}

export default FooterNav
